import DisplayWorkspace from '@/components/google-ads/display/DisplayWorkspace';
import { AWARENESS_OBJECTIVE } from './awarenessObjective';

/** AWARENESS & REACH WORKSPACE — /google-ads/awareness */
export default function AwarenessPage() {
  return <DisplayWorkspace cfg={AWARENESS_OBJECTIVE} />;
}
